export default __webpack_public_path__ + "static/media/scrollingweapons.08625dba.png";